import { client } from '@/client';
import { Course } from '@/client/courses';
import { CustomizeCourseRequest } from '@/client/courses/types/course-customization.type';
import { MessageResponse } from '@/client/types';
import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from 'react-query';

export type ReplaceScheduledContentRequest = {
  accountId: string;
  originalCourseId: string;
  customizedCourseId: string;
};

export const useCustomizeCourse = (
  options?: UseMutationOptions<Course, Error, CustomizeCourseRequest>,
): UseMutationResult<Course, Error, CustomizeCourseRequest> => {
  return useMutation(
    (request) =>
      client.courses.customizeCourse(
        request.accountId,
        request.courseId,
        request.language,
      ),
    {
      ...options,
    },
  );
};

export const useReplaceScheduledContent = (
  options?: UseMutationOptions<
    MessageResponse,
    Error,
    ReplaceScheduledContentRequest
  >,
): UseMutationResult<
  MessageResponse,
  Error,
  ReplaceScheduledContentRequest
> => {
  return useMutation(
    (request) =>
      client.courses.replaceScheduledContent(
        request.accountId,
        request.originalCourseId,
        request.customizedCourseId,
      ),
    {
      ...options,
    },
  );
};
